import React, { ReactElement, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getGifListIds, getZoomLevel, getHasMore } from "../../state/selectors";
import ListItem from "../ListItem";
import "./styles.scss";
import { State } from "../../state/types";
import InfiniteScroll from "react-infinite-scroller";
import { loadMore, performSearch } from "../../state/actions";
import CircularProgress from "@material-ui/core/CircularProgress";

interface Props {}

let cellSize: { [key in State["zoomLevel"]]: number } = {
  1: 80,
  2: 120,
  3: 180,
  4: 260,
  5: 300,
};

export default function List({}: Props): ReactElement {
  const dispatch = useDispatch();
  const gifIds = useSelector(getGifListIds());
  const zoomLevel = useSelector(getZoomLevel());
  const hasMore = useSelector(getHasMore());

  const style = {
    "--cell-size": `${cellSize[zoomLevel]}px`,
  } as React.CSSProperties;

  useEffect(() => {
    dispatch(performSearch("dogs"));
  }, []);

  return (
    <InfiniteScroll
      className="p-4 max-w-6xl flex-grow w-full"
      element={"section"}
      pageStart={0}
      loadMore={() => dispatch(loadMore())}
      hasMore={false}
      loader={
        <li aria-hidden key={0} className="w-full flex justify-center mt-10">
          <CircularProgress size={100} />
        </li>
      }
    >
      <h1 className="sr-only">Search Results</h1>
      <ul style={style} className="list">
        {gifIds.map((id) => (
          <ListItem key={id} gifId={id} />
        ))}
      </ul>
    </InfiniteScroll>
  );
}
